"use client";

import Wrapper from "@/components/organisms/Wrapper";
import { Title } from "@/components/atoms/Title/title";
import Button from "@/components/atoms/Button";
import ServerErrorIcon from "@/assets/svg/server-error-icon.svg";
import RefreshIcon from "@/assets/svg/refresh.svg";
import "@/styles/global-error.scss";
import "../styles/_base.scss";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const refreshAndReset = () => {
    window.location.reload();
    reset();
  };

  return (
    <html data-scroll-behavior="smooth">
      <body>
        <Wrapper>
          <div
            className="serverError font--barlow"
            style={{ minHeight: "90vh", justifyContent: "center" }}>
            <ServerErrorIcon
              className="serverError__icon"
              alt="Server Error Icon"
            />
            <Title
              hero
              className="serverError__title"
              tag="h1"
              content={"Oops! Something went wrong."}
            />
            <p className="serverError__copy">
              We’re working on it. <br />
              Please keep this page open or try again later.
            </p>
            {error && (
              <small className="serverError__copy serverError__copy--error">{error.message}</small>
            )}
            <Button
              className="serverError__button"
              onClick={() => refreshAndReset()}
              tertiary
              noMargin
              iconLeft
              svg={<RefreshIcon />}
              label="Refresh Page"
            />
          </div>
        </Wrapper>
      </body>
    </html>
  );
}
